import React from "react";
import { ArrowUp, ArrowDown } from "react-feather";

const RankImpact = ({ rank, scrapedAt, rankStatus, rankDiffFromLastTime }) => {
  return (
    <>
      {rank === 0 && (scrapedAt === undefined || scrapedAt === null) ? (
        "Processing"
      ) : (
        <>{rank <= 0 ? "<100" : rank > 99 ? ">100" : rank}</>
      )}
      {rankStatus && (
        <>
          {rankStatus === "up" && (
            <span
              style={{
                width: "12px",
                color: "green",
                paddingRight: "4px",
                fontSize: "11px",
              }}
            >
              <ArrowUp style={{ width: "12px" }} />({rankDiffFromLastTime})
            </span>
          )}
          {rankStatus === "down" && (
            <span
              style={{
                width: "12px",
                color: "darkred",
                paddingRight: "4px",
                fontSize: "11px",
              }}
            >
              <ArrowDown style={{ width: "12px" }} />({rankDiffFromLastTime})
            </span>
          )}
        </>
      )}
    </>
  );
};

export default RankImpact;
